import React, { useEffect, useState } from "react";
import ReportHeader from "../../../common/ReportHeader";
import { Box, Divider, Typography } from "@mui/material";
import ReportTableFilter from "../../../common/ReportTableFilter";
import ExcelAndPrint from "../../../common/ExcelAndPrint";
import VirtualizedTable from "../../../common/VirtualizedTable";
import {
  inquiryOneColDef,
  inquiryOneFilterCol,
  inquiryOneTotalColDef,
} from "../../Reports/constants";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { showErrorAlert } from "../../../redux/Actions";
import { getInquiryReportData } from "../../../redux/Report/ReportActions";
import dayjs from "dayjs";
import { reportGenerationDateFormat2 } from "../../../common/constant";
import moment from "moment";
import { decryptText } from "../../../utils/Decrypt";

const InquiryOneReport = () => {
  const dispatch = useDispatch();
  const [tableData, setTableData] = useState([]);
  const [searchParams] = useSearchParams();
  const [paramsLoaded, setParamsLoaded] = useState(false);
  let decryptedData = {}
  try {
    const paramData = searchParams.get("data");
    if (paramData) {
      decryptedData = JSON.parse(decryptText(decodeURIComponent(paramData)));
    }
  } catch (error) {
    console.error("Invalid query data:", error);
  }


  let { intAgentID, intFromCityId, intToCityID, intRouteName, dtJourneyDate, intTripID, intBusNumber, intBusTypeID } = decryptedData

  useEffect(() => {
    if (searchParams.toString()) {
      setParamsLoaded(true);
    }
  }, [searchParams]);
  const groupData = (apiData = []) => {
    const grouped = apiData.reduce((acc, item) => {
      const key = item.BookedByUserName || "Unknown";
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {});
    const sortedUsers = Object.keys(grouped).sort((a, b) => a.localeCompare(b));
    let tableRows = [];
    let grandTotalSeats = 0;
    let grandTotalFare = 0;
    sortedUsers.forEach((userName) => {
      let userSeatsTotal = 0;
      let userFareTotal = 0;
      tableRows.push({
        isSubHeadingRow: true,
        subHeadingData: [{ caption: userName, colSpan: 12 }],
      });
      let sortGoupedData = grouped[userName].sort((a, b) => moment(a.PickupTime).valueOf() - moment(b.PickupTime).valueOf())
      sortGoupedData.forEach((item) => {
        const seatsCount = Number(item.TotalSeatsCount || 0);
        const fare = Number(item.TotalFare || 0);
        userSeatsTotal += seatsCount;
        userFareTotal += fare;
        tableRows.push({
          ...item,
          pnr: item.PNRNo,
          user: item.OperatorName,
          seatsCount: seatsCount,
          seats: item.AllSeats,
          customer: item.CustomerName,
          phone: item.CustomerPhone1,
          from: item.FromCityShortName,
          to: item.ToCityShortName,
          pickup: item.PickupAddress,
          type: item.AgentName,
          fare: fare.toFixed(2),
        });
      });
      tableRows.push({
        isTotalRow: true,
        label: "Total:",
        seatsCount: userSeatsTotal,
        fare: userFareTotal.toFixed(2),
      });
      grandTotalSeats += userSeatsTotal;
      grandTotalFare += userFareTotal;
    });
    tableRows.push({
      isTotalRow: true,
      label: "Grand Total:",
      seatsCount: grandTotalSeats,
      fare: grandTotalFare.toFixed(2),
    });
    return tableRows;
  };

  useEffect(() => {
    if (!paramsLoaded) return;
    const requiredFields = [intAgentID, intFromCityId, intToCityID, intTripID, dtJourneyDate];
    const hasError = requiredFields.some(
      (val) => val === undefined || val === null
    );
    if (hasError) {
      dispatch(showErrorAlert("Invalid URL: Missing required parameters"));
      return;
    }
    const body = {
      intAgentID: Number(intAgentID),
      intFromCityId: intFromCityId,
      intToCityID: intToCityID,
      dtJourneyDate: dtJourneyDate,
      intTripID: intTripID,
    };

    dispatch(getInquiryReportData(body))
      .then((res) => {
        if (res.data.status) {
          const parsedData = JSON.parse(res.data.Data);
          const data = groupData(parsedData);
          setTableData(data);
        } else {
          dispatch(showErrorAlert(res.data.Message));
        }
      })
      .catch(() => {
        dispatch(showErrorAlert("Failed to load Branch Wise Inquiry report"));
      });
  }, [
    paramsLoaded,
    intAgentID,
    intFromCityId,
    intToCityID,
    dtJourneyDate,
    intTripID,
    intBusNumber,
    intBusTypeID,
    dispatch,
  ]);

  const filterData = {
    route: intRouteName,
    dtJourneyDate: dayjs(dtJourneyDate,'dd-MMM-yyyy').format("DD-MMM-YYYY"),
    busNo: intBusNumber,
    busAdv: intBusTypeID,
    reportDate: dayjs(window.getTime ? window.getTime() : new Date()).format(
      reportGenerationDateFormat2,
    ),
  };

  return (
    <>
      <ReportHeader reportitle="Branch Wise Inquiry Report" />
      <Box sx={{ padding: "12px 16px 8px 16px" }}>
        <ReportTableFilter columnDef={inquiryOneFilterCol} data={filterData} />
      </Box>
      <Box
        sx={{
          padding: "8px 16px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h6">Branch Wise Inquiry</Typography>
        <ExcelAndPrint
          reportTitle="Branch Wise Inquiry Report"
          multiTable={[
            {
              titleTable: "",
              columnDef: inquiryOneColDef,
              body: tableData,
            },
          ]}
          filterSectionColumn={inquiryOneFilterCol}
          filterSectionData={filterData}
        />
      </Box>
      <Divider />
      <Box sx={{ padding: "12px 16px" }}>
        <VirtualizedTable
          tableData={tableData}
          columnDefs={inquiryOneColDef}
          totalColumnDef={inquiryOneTotalColDef}
        />
      </Box>
    </>
  );
};

export default InquiryOneReport;